import { useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


export interface SegmentValue {
    contextId
    : 
  number;
    contextValue
    : 
    string;
    realmId: string;
    segmentId : number;
    userId: number;
}

const getSegmentValue = async (segmentId:string) => {
  try {
    const url = paths.getSegmentValue();
    const response = await axiosInstance.post(url, {input: {query:`segmentId==${segmentId}`}});
    const segmentValues = response?.data?.data?.segmentValues?.result||[];

    const contextValues:string[] = segmentValues.map((item:SegmentValue) => {
     return  item.contextValue
    })
    const contextId:string = segmentValues?.[0]?.contextId.toString()||'';
    return {contextValues,contextId};
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetSegmentValue = (segmentId:string,options?:any) => {
    return useQuery(['get-segment-value', segmentId], () => getSegmentValue(segmentId), {
        refetchInterval: false,
        refetchOnWindowFocus: false,
    ...options
    });
  };